import { createReducer } from 'reduxsauce';
import { METADATA } from 'actions/Base';

export const INITIAL_STATE = {
  list: [],
  hobbies: [],
  isLoading: false,
};

export const onGetRequest = (state) => ({ ...state, isLoading: true });

export const onGetFailure = (state) => ({ ...state, isLoading: false });

export const onGetSuccess = (state, { payload }) => ({ ...state, isLoading: false, list: payload });

export const onGetHobbiesRequest = (state) => ({ ...state, isLoading: true });

export const onGetHobbiesFailure = (state) => ({ ...state, isLoading: false });

export const onGetHobbiesSuccess = (state, { payload }) => ({ ...state, isLoading: false, hobbies: payload });

export const ACTION_HANDLERS = {
  [METADATA.GET_REQUEST]: onGetRequest,
  [METADATA.GET_FAILURE]: onGetFailure,
  [METADATA.GET_SUCCESS]: onGetSuccess,

  [METADATA.GET_HOBBIES_REQUEST]: onGetHobbiesRequest,
  [METADATA.GET_HOBBIES_FAILURE]: onGetHobbiesFailure,
  [METADATA.GET_HOBBIES_SUCCESS]: onGetHobbiesSuccess,
};

export default createReducer(INITIAL_STATE, ACTION_HANDLERS);
